import React from 'react';
import { Dialog, DialogType, DialogFooter, PrimaryButton } from '@fluentui/react';
import IvicosStrings from 'kits/language/stringKit';

interface ILobbyInactivityWarningModalProps {
    isOpen: boolean;
    countdownSeconds: number;
    onStay: () => void;
    themeColor?: string;
}

function formatCountdown(seconds: number): string {
    const m = Math.floor(seconds / 60);
    const s = seconds % 60;
    return `${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`;
}

const LobbyInactivityWarningModal: React.FC<ILobbyInactivityWarningModalProps> = ({ isOpen, countdownSeconds, onStay, themeColor }) => {
    return (
        <Dialog
            hidden={!isOpen}
            dialogContentProps={{
                type: DialogType.normal,
                title: IvicosStrings.lobbyInactivityWarningTitle,
                subText: `${IvicosStrings.lobbyInactivityWarningText} ${formatCountdown(countdownSeconds)}`
            }}
            modalProps={{
                isBlocking: true,
                styles: { main: { maxWidth: 450 } }
            }}
        >
            <DialogFooter>
                <PrimaryButton
                    onClick={onStay}
                    text={IvicosStrings.lobbyInactivityWarningButton}
                    styles={{ root: { backgroundColor: themeColor, borderColor: themeColor } }}
                />
            </DialogFooter>
        </Dialog>
    );
};

export default LobbyInactivityWarningModal;
